import AddIcon from "@mui/icons-material/Add";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import MapPicker from "react-google-map-picker";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import {
  getDetailExcoPusat,
  patchExcoDetail,
} from "../../../config/Redux/ExcoPusat/actions";
import {
  getProvince,
  getKabKot,
  getKecamatan,
  getKelurahan,
} from "../../../config/Redux/Global/actions";
import { Gap, MyAutocomplete, MyButton, MyInput } from "../../atoms";
import MyDialog from "../../molecules/Dialog";
import AlertMessage from "../../../components/molecules/AlertMessage";
import "./detailexco.css";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";

const validationSchema = yup.object().shape({
  alamat: yup.string("Masukan Alamat").required("Silahkan Masukan Alamat"),
  provinsi: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Provinsi"),
  kabkot: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Kabupaten / Kota"),
  kecamatan: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Kecamatan"),
  kelurahan: yup
    .object()
    .shape({
      label: yup.string(),
      id: yup.string(),
    })
    .nullable()
    .required("Silahkan Masukan Kelurahan"),
  alamat_rt: yup
    .string()
    .required("Silahkan Masukkan RT")
    .matches(/^[0-9]+$/, "Hanya menerima masukkan angka")
    .min(3, "Harus 3 angka")
    .max(3, "Harus 3 angka"),
  alamat_rw: yup
    .string()
    .required("Silahkan Masukkan RW")
    .matches(/^[0-9]+$/, "Hanya menerima masukkan angka")
    .min(3, "Harus 3 angka")
    .max(3, "Harus 3 angka"),
});

const AlamatKantor = ({
  officeId: propOfficeId,
  tingkatExcoId: propTingkatExcoId,
  daerahId: propDaerahId,
  isLocked: propIsLocked,
}) => {
  const dataDetailExcoPusat = useSelector(
    (state) => state.excopusat.dataDetailExcoPusat,
  );

  let dataDetail = dataDetailExcoPusat && dataDetailExcoPusat.data;
  // console.log(`dataDetail`, dataDetail);
  let coordinate = dataDetail?.koordinat;
  const DefaultLocation = {
    lat: parseInt(coordinate?.latitude),
    lng: parseInt(coordinate?.longitude),
  };
  const urlParams = useParams();
  // Use props if available, otherwise fallback to URL params
  const officeId = propOfficeId || urlParams.officeId;
  const tingkatExcoId = propTingkatExcoId || urlParams.tingkatExcoId;
  const daerahId = propDaerahId || urlParams.daerahId;
  // Use prop for isLocked if provided, otherwise fallback to Redux state
  const isLocked =
    propIsLocked !== undefined
      ? propIsLocked
      : parseInt(dataDetailExcoPusat?.data?.is_locked) === 1;
  // const [defaultLocation, setDefaultLocation] = React.useState(DefaultLocation);
  const [location, setLocation] = React.useState(DefaultLocation);
  function handleChangeLocation(lat, lng) {
    setLocation({ lat: lat, lng: lng });
  }

  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [idProvinsi, setIdProvinsi] = React.useState(null);

  // alert message
  const [openDialogAlert, setOpenDialogAlert] = React.useState(false);
  const [message, setMessage] = React.useState("");
  const [status, setStatus] = React.useState(null);

  //  selector
  const province = useSelector((state) => state.global.dataProvince);
  const kabkot = useSelector((state) => state.global.dataKabKot);
  const kecamatan = useSelector((state) => state.global.dataKecamatan);
  const kelurahan = useSelector((state) => state.global.dataKelurahan);
  // console.log("kk",s)

  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
  //cek hak akses
  const checkHakAkses = (list, akses, is_locked) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
    });
    return has;
  };

  const convertDate = (date) => {
    if (
      !date ||
      date === "0000-00-00" ||
      new Date(date).toString() === "Invalid Date"
    ) {
      return "";
    }
    let months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Agu",
      "Sep",
      "Okt",
      "Nov",
      "Des",
    ];
    var local = new Date(date);
    return (
      local.getDate() +
      " " +
      months[local.getMonth()] +
      " " +
      local.getFullYear()
    );
  };
  const convertDateFormatted = (date) => {
    if (
      !date ||
      date === "0000-00-00" ||
      new Date(date).toString() === "Invalid Date"
    ) {
      return "";
    }
    var local = new Date(date);
    let temp =
      local.getFullYear() +
      "-" +
      String(local.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(local.getDate()).padStart(2, "0");
    return temp;
  };

  const formik = useFormik({
    initialValues: {
      provinsi:
        dataDetail?.alamat?.alamat_id_provinsi &&
        dataDetail?.alamat?.alamat_provinsi
          ? {
              id: dataDetail?.alamat?.alamat_id_provinsi,
              label: dataDetail?.alamat?.alamat_provinsi,
            }
          : null,
      kabkot:
        dataDetail?.alamat?.alamat_id_kab_kot &&
        dataDetail?.alamat?.alamat_kab_kot
          ? {
              id: dataDetail?.alamat?.alamat_id_kab_kot,
              label: dataDetail?.alamat?.alamat_kab_kot,
            }
          : null,
      kecamatan:
        dataDetail?.alamat?.alamat_id_kecamatan &&
        dataDetail?.alamat?.alamat_kecamatan
          ? {
              id: dataDetail?.alamat?.alamat_id_kecamatan,
              label: dataDetail?.alamat?.alamat_kecamatan,
            }
          : null,
      kelurahan:
        dataDetail?.alamat?.alamat_id_kelurahan &&
        dataDetail?.alamat?.alamat_kelurahan
          ? {
              id: dataDetail?.alamat?.alamat_id_kelurahan,
              label: dataDetail?.alamat?.alamat_kelurahan,
            }
          : null,
      alamat: dataDetail?.alamat?.alamat_detail || "",
      alamat_rt: dataDetail?.alamat?.alamat_rt || "",
      alamat_rw: dataDetail?.alamat?.alamat_rw || "",
      kode_pos: dataDetail?.alamat?.alamat_kode_pos || "",
      batas_akhir_perjanjian: dataDetail?.batas_akhir_perjanjian
        ? convertDateFormatted(dataDetail.batas_akhir_perjanjian)
        : "",
      notes: dataDetail?.notes || "",
      no_telp: dataDetail?.no_telp || "",
      status_kantor: dataDetail?.status_kantor
        ? {
            id: dataDetail?.status_kantor,
            label: dataDetail?.status_kantor,
          }
        : null,
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let payload = {
        // id_provinsi: values.provinsi.id,
        // id_kabkot: values.kabkot.id,
        // id_kecamatan: values.kecamatan.id,
        // id_kelurahan: values.kelurahan.id,
        alamat_detail: values.alamat,
        provinsi: values.provinsi.id,
        kab_kot: values.kabkot.id,
        kecamatan: values.kecamatan.id,
        kelurahan: values.kelurahan.id,
        alamat_rt: values.alamat_rt,
        alamat_rw: values.alamat_rw,
        alamat_kode_pos: values.kode_pos,
        longitude: location.lng,
        latitude: location.lat,
        batas_akhir_perjanjian: values.batas_akhir_perjanjian || null,
        notes: values.notes,
        no_telp: values.no_telp,
        status_kantor: values.status_kantor?.id || "",
      };
      // console.log(`payload`, payload);
      const resp = await dispatch(patchExcoDetail(officeId, payload));
      if (resp.type === "PATCH_EXCO_PUSAT_SUCCESS") {
        handleCloseDialog();
        await dispatch(getDetailExcoPusat(tingkatExcoId, daerahId));
        setMessage(resp.payload.message);
        setOpenDialogAlert(true);
        setStatus("");
      } else {
        setMessage(resp.payload.data.message);
        setOpenDialogAlert(true);
        setStatus("error");
      }
    },
  });
  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    formik.resetForm();
    setOpenDialog(false);
  };

  let optionsProv = province?.data?.map((item) => ({
    label: item.nama_prov_kemdagri,
    id: item.kode_prov_bps,
  }));

  let optionsKabKot = kabkot?.data?.map((item) => ({
    label: item.nama_kab_kota_kemdagri,
    id: item.kode_kab_kota_bps,
  }));
  let optionsKecamatan = kecamatan?.data?.map((item) => ({
    label: item.nama_kec_bps,
    id: item.kode_kec_bps,
  }));
  let optionsKelurahan = kelurahan?.data?.map((item) => ({
    label: item.nama_kel_des_bps,
    id: item.kode_kel_desa_bps,
  }));

  const renderValue = (
    <>
      <div align="center" style={{ fontSize: 22, fontWeight: 700 }}>
        <p>Ubah Data</p>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          formik.handleSubmit(e);
        }}
      >
        <MyAutocomplete
          id="provinsi"
          name="provinsi"
          fullWidth
          options={optionsProv || []}
          // handleChange={(e, value) => formik.setFieldValue("provinsi", value)}
          size="medium"
          label="Provinsi"
          renderInput={(params) => <MyInput {...params} label="Provinsi" />}
          value={formik.values.provinsi}
          onChange={(e, value) => {
            dispatch(getKabKot(value.id));
            setIdProvinsi(value.id);
            formik.setFieldValue("provinsi", value);
            formik.setFieldValue("kabkot", null);
            formik.setFieldValue("kecamatan", null);
            formik.setFieldValue("kelurahan", null);
          }}
        />
        <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.provinsi && formik.errors.provinsi}
        </FormHelperText>
        <Gap height={10} />
        <MyAutocomplete
          fullWidth
          size="medium"
          label="Kabupaten / Kota*"
          options={optionsKabKot || []}
          id="kabkot"
          name="kabkot"
          value={formik.values.kabkot}
          // handleChange={(e, value) => formik.setFieldValue("kabkot", value)}
          onChange={(e, value) => {
            dispatch(
              getKecamatan(`provinsi=${idProvinsi}&kotaKab=${value.id}`),
            );
            formik.setFieldValue("kabkot", value);
            formik.setFieldValue("kecamatan", null);
            formik.setFieldValue("kelurahan", null);
          }}
        />
        <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.kabkot && formik.errors.kabkot}
        </FormHelperText>
        <Gap height={10} />
        <MyAutocomplete
          fullWidth
          size="medium"
          label="Kecamatan"
          id="kecamatan"
          options={optionsKecamatan || []}
          name="kecamatan"
          value={formik.values.kecamatan}
          onChange={(e, value) => {
            dispatch(getKelurahan(`kecamatan=${value.id}`));
            formik.setFieldValue("kecamatan", value);
            formik.setFieldValue("kelurahan", null);
          }}
        />
        <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.kecamatan && formik.errors.kecamatan}
        </FormHelperText>
        <Gap height={10} />
        <MyAutocomplete
          fullWidth
          size="medium"
          label="Kelurahan"
          id="kelurahan"
          name="kelurahan"
          options={optionsKelurahan || []}
          value={formik.values.kelurahan}
          onChange={(e, value) => {
            formik.setFieldValue("kelurahan", value);
          }}
        />
        <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.kelurahan && formik.errors.kelurahan}
        </FormHelperText>
        <Gap height={10} />
        <MyInput
          id="alamat_rt"
          name="alamat_rt"
          label='RT (jika tidak memiliki RT harap diisi "000")'
          fullWidth
          size="medium"
          value={formik.values.alamat_rt}
          onChange={formik.handleChange}
          error={formik.touched.alamat_rt && Boolean(formik.errors.alamat_rt)}
          helperText={formik.touched.alamat_rt && formik.errors.alamat_rt}
        />
        <Gap height={10} />
        <MyInput
          id="alamat_rw"
          name="alamat_rw"
          label='RW (jika tidak memiliki RW harap diisi "000")'
          fullWidth
          size="medium"
          value={formik.values.alamat_rw}
          onChange={formik.handleChange}
          error={formik.touched.alamat_rw && Boolean(formik.errors.alamat_rw)}
          helperText={formik.touched.alamat_rw && formik.errors.alamat_rw}
        />
        <Gap height={10} />
        <MyInput
          id="alamat"
          name="alamat"
          label="Alamat (TANPA perlu mencantumkan RT/RW dan nama daerah)"
          fullWidth
          size="medium"
          value={formik.values.alamat}
          onChange={formik.handleChange}
          error={formik.touched.alamat && Boolean(formik.errors.alamat)}
          helperText={formik.touched.alamat && formik.errors.alamat}
          multiline
          rows={2}
        />
        <Gap height={10} />
        <MyInput
          id="kode_pos"
          name="kode_pos"
          label="Kode Pos"
          fullWidth
          size="medium"
          value={formik.values.kode_pos}
          onChange={formik.handleChange}
        />
        <Gap height={10} />
        <MyInput
          id="no_telp"
          name="no_telp"
          label="No Telp Kantor/Ketua"
          fullWidth
          size="medium"
          value={formik.values.no_telp}
          onChange={formik.handleChange}
          // error={formik.touched.alamat && Boolean(formik.errors.alamat)}
          // helperText={formik.touched.alamat && formik.errors.alamat}
        />
        <Gap height={10} />
        <MyAutocomplete
          fullWidth
          size="medium"
          label="Status Kantor"
          id="status_kantor"
          name="status_kantor"
          options={
            [
              {
                label: "Sewa",
                id: "Sewa",
              },
              {
                label: "Hak Milik",
                id: "Hak Milik",
              },
            ] || []
          }
          value={formik.values.status_kantor}
          onChange={(e, value) => {
            formik.setFieldValue("status_kantor", value);
          }}
        />
        {/* <FormHelperText id="component-error-text" style={{ color: "red" }}>
          {formik.touched.kelurahan && formik.errors.kelurahan}
        </FormHelperText> */}
        <Gap height={10} />
        <MyInput
          type="date"
          id="batas_akhir_perjanjian"
          name="batas_akhir_perjanjian"
          label="Batas Sewa"
          fullWidth
          size="medium"
          InputLabelProps={{ shrink: true }}
          value={formik.values.batas_akhir_perjanjian}
          onChange={formik.handleChange}
          // error={formik.touched.alamat && Boolean(formik.errors.alamat)}
          // helperText={formik.touched.alamat && formik.errors.alamat}
        />
        <Gap height={10} />
        <MyInput
          id="notes"
          name="notes"
          label="Catatan"
          fullWidth
          size="medium"
          value={formik.values.notes}
          onChange={formik.handleChange}
          // error={formik.touched.alamat && Boolean(formik.errors.alamat)}
          // helperText={formik.touched.alamat && formik.errors.alamat}
          multiline
          rows={2}
        />
        <Gap height={10} />
        {/* <MyMapLeaflet scroll={true} /> */}
        {/* <p>Lokasi Kantor</p>
        <MapPicker
          defaultLocation={location}
          zoom={5}
          mapTypeId="roadmap"
          disabled
          style={{ height: "300px" }}
          onChangeLocation={handleChangeLocation}
          // onChangeZoom={handleChangeZoom}
          apiKey="AIzaSyD__O4p4zDTowzZbRAtjo-ke7hPGkEQo-g"
        /> */}
        <Gap height={10} />
        <div style={{ display: "flex" }}>
          <MyButton
            height="40px"
            color="#B9B9B9"
            fullWidth
            backgroundColor="#FFFFFFFF"
            borderColor="#B9B9B9"
            backgroundColorHover="#FFFFFFFF"
            variant="outlined"
            children="Batal"
            onClick={handleCloseDialog}
          />
          <Gap width={30} />
          <MyButton
            height="40px"
            color="#8B8B8B"
            colorHover="white"
            fullWidth
            backgroundColor="#E8E8E8"
            borderColor="#E8E8E8"
            backgroundColorHover="#F06524"
            variant="outlined"
            children="Simpan"
            type="submit"
          />
        </div>
      </form>
    </>
  );

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    dispatch(getProvince());
    if (tingkatExcoId && daerahId) {
      dispatch(getDetailExcoPusat(tingkatExcoId, daerahId));
    }
  }, [dispatch, tingkatExcoId, daerahId]);

  return (
    <>
      <MyDialog
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        renderValue={renderValue}
        fullWidth={true}
        maxWidth={"sm"}
      />

      {/* alertMessage */}
      <AlertMessage
        openDialog={openDialogAlert}
        message={message}
        status={status}
        handleCloseDialog={() => setOpenDialogAlert(false)}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: -15,
        }}
      >
        <p style={{ fontSize: 22, color: "#8B8B8B" }}>Alamat Kantor</p>
        {!isLocked &&
        (checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") ||
          checkHakAkses(
            profile?.data?.hak_akses,
            "Document Manager Access",
          )) ? (
          <MyButton
            style={{ marginTop: 25 }}
            startIcon={<AddIcon />}
            height="100%"
            color="white"
            backgroundColor="#FF9000"
            borderColor="#FF9000"
            backgroundColorHover="#FF9000"
            variant="outlined"
            children="Ubah Alamat"
            onClick={handleOpenDialog}
          />
        ) : null}
      </div>
      <Grid container spacing={3}>
        {/* <Grid item xs={12} md={12}>
          <Gap height={20} />
          {dataDetail?.alamat?.alamat_detail || ""}, RT {dataDetail?.alamat?.alamat_rt || ""} RW {dataDetail?.alamat?.alamat_rw || ""}
          , Kelurahan {dataDetail?.alamat?.alamat_kelurahan || ""}, Kecamatan {dataDetail?.alamat?.alamat_kecamatan || ""}
          , {dataDetail?.alamat?.alamat_kab_kot || ""}, Provinsi {dataDetail?.alamat?.alamat_provinsi || ""}
        </Grid> */}
        <Grid item xs={12} md={12}>
          <Gap height={20} />
          <table>
            <tbody>
              <tr>
                <td>Provinsi </td>
                <td>: {dataDetail?.alamat?.alamat_provinsi || ""}</td>
              </tr>
              <tr>
                <td>Kab/Kota </td>
                <td>: {dataDetail?.alamat?.alamat_kab_kot || ""}</td>
              </tr>
              <tr>
                <td>Kecamatan </td>
                <td>: {dataDetail?.alamat?.alamat_kecamatan || ""}</td>
              </tr>
              <tr>
                <td>Kelurahan </td>
                <td>: {dataDetail?.alamat?.alamat_kelurahan || ""}</td>
              </tr>
              <td>RT/RW </td>
              <td>
                : {dataDetail?.alamat?.alamat_rt || ""}/
                {dataDetail?.alamat?.alamat_rw || ""}
              </td>

              <tr>
                <td>Alamat </td>
                <td>: {dataDetail?.alamat?.alamat_detail || ""}</td>
              </tr>
              <tr>
                <td>Kode Pos </td>
                <td>: {dataDetail?.alamat?.alamat_kode_pos || ""}</td>
              </tr>
              <tr>
                <td>No Telp Kantor/Ketua </td>
                <td>: {dataDetail?.no_telp || ""}</td>
              </tr>
              <tr>
                <td>Status Kantor </td>
                <td>: {dataDetail?.status_kantor || ""}</td>
              </tr>
              <tr>
                <td>Batas Sewa </td>
                <td>
                  :{" "}
                  {dataDetail?.batas_akhir_perjanjian
                    ? convertDate(dataDetail.batas_akhir_perjanjian)
                    : ""}
                </td>
              </tr>
              <tr>
                <td>Catatan </td>
                <td>: {dataDetail?.notes || ""}</td>
              </tr>
            </tbody>
          </table>
          {/* Alamat : {dataDetail?.alamat?.alamat_detail || ""}<br/>
          RT/RW : {dataDetail?.alamat?.alamat_rt || ""}/{dataDetail?.alamat?.alamat_rw || ""}<br/>
          Kelurahan : {dataDetail?.alamat?.alamat_kelurahan || ""}<br/>
          Kecamatan : {dataDetail?.alamat?.alamat_kecamatan || ""}<br/>
          Kab/Kota : {dataDetail?.alamat?.alamat_kab_kot || ""}<br/>
          Provinsi : {dataDetail?.alamat?.alamat_provinsi || ""}<br/> */}
          {/* {dataDetail?.alamat?.alamat_detail || ""}, RT {dataDetail?.alamat?.alamat_rt || ""} RW {dataDetail?.alamat?.alamat_rw || ""}
          , Kelurahan {dataDetail?.alamat?.alamat_kelurahan || ""}, Kecamatan {dataDetail?.alamat?.alamat_kecamatan || ""}
          , {dataDetail?.alamat?.alamat_kab_kot || ""}, Provinsi {dataDetail?.alamat?.alamat_provinsi || ""} */}
        </Grid>
        {/* <Grid item xs={12} md={6}>
          <MyInput
            label="Provinsi"
            disabled
            value={dataDetail?.alamat?.alamat_provinsi || ""}
            fullWidth
            size="medium"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyInput
            label="Kabupaten / Kota"
            disabled
            value={dataDetail?.alamat?.alamat_kab_kot || ""}
            fullWidth
            size="medium"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyInput
            label="Kecamatan"
            disabled
            value={dataDetail?.alamat?.alamat_kecamatan || ""}
            fullWidth
            size="medium"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyInput
            label="Kelurahan"
            disabled
            value={dataDetail?.alamat?.alamat_kelurahan || ""}
            fullWidth
            size="medium"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyInput
            label="RT"
            disabled
            value={dataDetail?.alamat?.alamat_rt || ""}
            fullWidth
            size="medium"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyInput
            label="RW"
            disabled
            value={dataDetail?.alamat?.alamat_rw || ""}
            fullWidth
            size="medium"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <MyInput
            label="Alamat"
            disabled
            value={dataDetail?.alamat?.alamat_detail || ""}
            fullWidth
            size="medium"
            multiline
            rows={4}
          />
        </Grid> */}
        {/* <Grid item xs={12} md={12}>
          <MyButton
            startIcon={<MyLocationIcon />}
            height="40px"
            color="#B9B9B9"
            colorHover="white"
            fullWidth
            backgroundColor="#FFFFFFFF"
            borderColor="#FF9000"
            backgroundColorHover="#FF9000"
            variant="outlined"
            children="Lihat Peta"
            onClick={() =>
              //           parseInt(coordinate?.latitude),
              // lng: parseInt(coordinate?.longitude),
              window.open(
                `https://maps.google.com/?q=${coordinate?.latitude},${coordinate?.longitude}`,
              )
            }
          />
          <Gap height={20} />
        </Grid> */}
      </Grid>
      <Gap height={20} />
    </>
  );
};

export default AlamatKantor;
